import { DashboardWidget } from '../../Dashboard/DashboardWidget/DashboardWidget';

const def: DashboardWidgetDefinition = {
    id: 'suspended_portfolios',
    title: 'Suspended Portfolios',
    type: 'portfolio',
    queryMeta: {
        dataVariant: 'report',
    },
    filters: [
        {
            id: 'isSuspended',
            value: true,
        },
    ],
    columnIds: [
        'householdName',
        'portfolioName',
        'accountAlias',
        'referencePortfolio',
        'nav',
        'isClientDirected',
        'suspendedAt',
    ],
};

export const SuspendedPortfolios = () => <DashboardWidget widgetDefinition={def} />;
